export const TRANSFER_SCHEME_PAYMENT = 'transferSchemePayment';
export const TRANSFER_JOB_CHANGE = 'transferJobChange';
export const TRANSFER_COVERAGE = 'transferCoverage';
export const TRANSFER_SAVINGS_INSURANCE = 'transferSavingsInsurance';
